import { contains, isEmpty, tryFind, ofArray, collect, length, head, map, sortBy } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { List_groupBy } from "../fable_modules/fable-library-js.4.28.0/Seq2.js";
import { TagGroupModule_fromInt, TagGroup, TagGroupModule_allGroups, TagGroupModule_label, TagGroupModule_toInt, TagFormat_parse } from "../Shared/Types.js";
import { numberHash, int32ToString, createObj, comparePrimitives, stringHash } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { createElement } from "react";
import { Tags_merge, Tags_mergeHint, Tags_noTags, Tags_title, Tags_delete, Tags_rename, Common_cancel, Rel_save, Tags_guestsCount } from "../Shared/Tr.js";
import { t as t_3, ta } from "../Lang.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Msg } from "../App/Messages.js";
import { compare } from "../fable_modules/fable-library-js.4.28.0/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { tryParse } from "../fable_modules/fable-library-js.4.28.0/Int32.js";
import { FSharpRef } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { collect as collect_1, append, singleton, map as map_1, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { helpIcon } from "./Components.js";
import { map as map_2, defaultArg } from "../fable_modules/fable-library-js.4.28.0/Option.js";

function collectTagsWithCounts(guests) {
    return sortBy((tupledArg_1) => tupledArg_1[0].toLowerCase(), map((tupledArg) => {
        const tags = tupledArg[1];
        return [head(tags), length(tags)];
    }, List_groupBy((t) => t.toLowerCase(), collect((g) => TagFormat_parse(g.Tags), guests), {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    })), {
        Compare: comparePrimitives,
    });
}

function tagBadge(tag, count, isSelected, onToggle) {
    let elems, tupledArg;
    return createElement("span", createObj(ofArray([["className", "tag-mgmt-badge" + (isSelected ? " tag-mgmt-badge-selected" : "")], ["onClick", (_arg) => {
        onToggle();
    }], (elems = [createElement("span", {
        className: "tag-mgmt-badge-name",
        children: tag,
    }), createElement("span", {
        className: "tag-mgmt-badge-count",
        children: (tupledArg = Tags_guestsCount(int32ToString(count)), ta(tupledArg[0], tupledArg[1])),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function renameInput(tag, renameValue, dispatch) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "tag-mgmt-rename-form"], (elems = [createElement("input", {
        className: "form-input tag-mgmt-rename-input",
        type: "text",
        value: renameValue,
        autoFocus: true,
        onChange: (ev) => {
            dispatch(new Msg(238, [ev.target.value]));
        },
        onKeyDown: (e) => {
            switch (e.key) {
                case "Enter": {
                    dispatch(new Msg(240, [tag, renameValue]));
                    break;
                }
                case "Escape": {
                    dispatch(new Msg(239, []));
                    break;
                }
                default:
                    undefined;
            }
        },
    }), createElement("button", {
        className: "btn btn-sm btn-primary",
        children: t_3(Rel_save),
        onClick: (_arg) => {
            dispatch(new Msg(240, [tag, renameValue]));
        },
    }), createElement("button", {
        className: "btn btn-sm",
        children: t_3(Common_cancel),
        onClick: (_arg_1) => {
            dispatch(new Msg(239, []));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function tagGroupDropdown(tagName, registryTags, dispatch) {
    let elems;
    const tagRecord = tryFind((t) => (compare(t.Name, tagName, 5) === 0), registryTags);
    if (tagRecord == null) {
        return defaultOf();
    }
    else {
        const tag = tagRecord;
        return createElement("select", createObj(ofArray([["className", "form-input tag-group-select"], ["value", int32ToString(tag.TagGroup)], ["onChange", (ev) => {
            let matchValue;
            let outArg = 0;
            matchValue = [tryParse(ev.target.value, 511, false, 32, new FSharpRef(() => outArg, (v_1) => {
                outArg = (v_1 | 0);
            })), outArg];
            if (matchValue[0]) {
                dispatch(new Msg(231, [tag.Id, matchValue[1]]));
            }
        }], (elems = toList(delay(() => map_1((g) => createElement("option", {
            value: int32ToString(TagGroupModule_toInt(g)),
            children: t_3(TagGroupModule_label(g)),
        }), TagGroupModule_allGroups))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function tagRow(tag, count, isRenaming, renameValue, isSelectedForMerge, registryTags, dispatch) {
    let elems_3, elems_2;
    return createElement("div", createObj(ofArray([["className", "tag-mgmt-row"], (elems_3 = [createElement("input", {
        type: "checkbox",
        className: "tag-mgmt-merge-checkbox",
        checked: isSelectedForMerge,
        onChange: (ev) => {
            const _arg = ev.target.checked;
            dispatch(new Msg(241, [tag]));
        },
    }), createElement("div", createObj(ofArray([["className", "tag-mgmt-row-content"], (elems_2 = toList(delay(() => {
        let elems, tupledArg;
        return isRenaming ? singleton(renameInput(tag, renameValue, dispatch)) : append(singleton(createElement("div", createObj(ofArray([["className", "tag-mgmt-row-info"], (elems = [createElement("span", {
            className: "tag-badge",
            children: tag,
        }), createElement("span", {
            className: "tag-mgmt-count text-muted text-sm",
            children: (tupledArg = Tags_guestsCount(int32ToString(count)), ta(tupledArg[0], tupledArg[1])),
        }), tagGroupDropdown(tag, registryTags, dispatch)], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return singleton(createElement("div", createObj(ofArray([["className", "tag-mgmt-actions"], (elems_1 = [createElement("button", {
                className: "btn btn-xs",
                children: t_3(Tags_rename),
                onClick: (_arg_1) => {
                    dispatch(new Msg(237, [tag]));
                },
            }), createElement("button", {
                className: "btn btn-xs btn-danger",
                children: t_3(Tags_delete),
                onClick: (_arg_2) => {
                    dispatch(new Msg(243, [tag]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

export function view(state, dispatch) {
    let elems_4;
    const tagsWithCounts = collectTagsWithCounts(state.Guests);
    return createElement("div", createObj(ofArray([["className", "tag-management-container mt-3"], (elems_4 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "flex items-center gap-sm mb-1"], (elems = [createElement("h4", {
            children: t_3(Tags_title),
        }), helpIcon(() => {
            dispatch(new Msg(268, ["02", "tags"]));
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let matchValue;
            return append((matchValue = state.TagManagementError, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
                className: "alert alert-danger",
                children: matchValue,
            }))), delay(() => {
                let elems_1;
                return isEmpty(tagsWithCounts) ? singleton(createElement("p", {
                    className: "text-muted text-sm",
                    children: t_3(Tags_noTags),
                })) : append(singleton(createElement("div", createObj(ofArray([["className", "tag-mgmt-merge-bar"], (elems_1 = [createElement("span", {
                    className: "text-muted text-sm",
                    children: t_3(Tags_mergeHint),
                }), createElement("button", {
                    className: "btn btn-sm btn-primary",
                    children: t_3(Tags_merge),
                    disabled: length(state.TagMergeSelection) < 2,
                    onClick: (_arg) => {
                        dispatch(new Msg(242, []));
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let elems_3;
                    const tagsByGroup = map((tupledArg_1) => [tupledArg_1[0], map((tuple_2) => tuple_2[1], tupledArg_1[1])], sortBy((tuple_1) => tuple_1[0], List_groupBy((tuple) => tuple[0], map((tupledArg) => {
                        const tag = tupledArg[0];
                        return [defaultArg(map_2((t_1) => t_1.TagGroup, tryFind((t) => (compare(t.Name, tag, 5) === 0), state.Tags)), TagGroupModule_toInt(new TagGroup(5, []))), [tag, tupledArg[1]]];
                    }, tagsWithCounts), {
                        Equals: (x, y) => (x === y),
                        GetHashCode: numberHash,
                    }), {
                        Compare: comparePrimitives,
                    }));
                    return singleton(createElement("div", createObj(ofArray([["className", "tag-mgmt-list"], (elems_3 = toList(delay(() => collect_1((matchValue_1) => {
                        let elems_2;
                        const group = TagGroupModule_fromInt(matchValue_1[0]);
                        return singleton(createElement("div", createObj(ofArray([["className", "tag-mgmt-group"], (elems_2 = toList(delay(() => append(singleton(createElement("h5", {
                            className: "tag-mgmt-group-header text-muted text-sm",
                            children: t_3(TagGroupModule_label(group)),
                        })), delay(() => collect_1((matchValue_2) => {
                            let matchValue_3;
                            const tag_1 = matchValue_2[0];
                            return singleton(tagRow(tag_1, matchValue_2[1], (matchValue_3 = state.TagRenameEditing, (matchValue_3 == null) ? false : (matchValue_3 === tag_1)), state.TagRenameValue, contains(tag_1, state.TagMergeSelection, {
                                Equals: (x_2, y_2) => (x_2 === y_2),
                                GetHashCode: stringHash,
                            }), state.Tags, dispatch));
                        }, matchValue_1[1]))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                    }, tagsByGroup))), ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

